// Maps a URL/localStorage-persisted aggregation ('sum' | 'mean' | 'min' | 'max')
// to the PascalCase field name used on Analysis in the EnergyXplorer context.
//
export const ANALYSIS_AGGREGATION_FIELD = {
  sum: 'TotalEnergyUsage',
  mean: 'AverageEnergyUsage',
  min: 'MinEnergyUsage',
  max: 'MaxEnergyUsage',
};
